import React from "react";
import { Typography } from "antd";
import styles from "./subjects.module.css";  
import SubjectsViewTabs from "./components/subjects-view-tabs/subjects-view-tabs";
import SubjectStatisticsOverview from "./components/statistics-overview/statistics-overview";

const Subjects = () => {
  return (
    <div className={styles.teachers}>
      <Typography className={styles.title}>Overview</Typography>
      <SubjectStatisticsOverview />
      <SubjectsViewTabs />
    </div>
  );
};

export default Subjects;
